import {IStripeRefundReason} from "../interfaces/IStripeRefundReason";

export const StripeRefundReasons: IStripeRefundReason[] = [
  {
    description: 'Duplicate',
    value: 'duplicate'
  },
  {
    description: 'Fraudulent',
    value: 'fraudulent'
  },
  {
    description: 'Requested by Customer',
    value: 'requested_by_customer'
  }
]
